<template lang="pug">
  div.text-left
    template(v-if="$i18n.locale === 'ja'")
      section
        h1|TEBSTA サービス利用者 利用規約
        p|本 TEBSTA ユーザー利用規約（以下「本規約」という。）には、株式会社2way（以下「弊社」といいます。）の提供する「TEBSTA」（以下「本サービス」といい、理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含む。）のご利用にあたり、本サービスを通じてスペース（第１条第１項で定義する。）の利用を申し込む皆様（以下「ユーザー」といいます。）に遵守していただかなければならない事項及び弊社とユーザーの皆様との間の権利義務関係が定められております。本サービスをご利用になる方は、本規約に同意する前に、必ず全文お読み下さいますようお願い致します。

      section
        h1|【 第 1 条 本サービスについて 】
        p|1. 本サービスは、ユーザーの荷物（以下「荷物」という。）を置くための店舗又は事業所のスペース（以下「スペース」という。）においてユーザーの荷物を預かる事業者（以下「オーナー」という。）並びにスペースの空き及び保管状況に関する情報を、ユーザーに対して、弊社のウェブサイト又はアプリ（以下「ウェブサイト等」という。）上で提供するサービスです。
        p|2. 弊社は、本サービスにおいて、ユーザーの荷物を預かるオーナー並びにスペースの空き及び保管状況に関する情報を提供するに過ぎず、ユーザーとオーナーとの契約関係について一切関知しません。
        p|3. ユーザーとオーナーは、ユーザーの携帯品その他通常外出時に携帯する範囲内の物品並びに自転車の保管を目的とする寄託契約（以下「荷物預かり契約」という。）を締結するものであり、弊社がユーザーの荷物預かりに関する契約の当事者になるものではありません。ユーザーとオーナーとの契約は、幣社の権利義務に関するものを除き、本規約に優先して適用されるものとします。
        p|4. 本サービスの利用料金及び利用方法等については、本サービスを提供するウェブサイト等上に掲げられた内容とし、ユーザーは当該内容を理解した上で、本サービスの利用を申し込んだものとします。
        p|5. 利用料金については、時季及びスペースの保管状況によって変動することがあります。
        p|6. 利用料金の表示については、当該スペースに関するオーナーの個別のウェブサイト等に記載することとし、利用期間を超えた利用についての超過料金及びキャンセル料金についても同様とします。
        p|7. ユーザーは、本サービスの利用に際して、弊社が定めるクレジットカードを登録もしくは弊社が指定する電子マネーを利用して、当該クレジットカード決済、電子マネー決済の所定の支払時期に、オーナーに対するスペースに対する利用料金、キャンセル料金及び超過料金その他ウェブサイト等及び当該スペースの個別のウェブページ上に掲げられた費用を支払うこととします。但し、クレジットカードの利用による支払いが行われなかった場合は、ユーザーは弊社が定める方法で支払うものとします。
        p|8. 弊社は、前項で定めるユーザーのオーナーに対する弁済を、オーナーを代理して受領する権限を有しており、当該弁済をオーナーに代わって受領するものとし、ユーザーはこれに同意します。ユーザーのオーナーに対する債務は、弊社がユーザーからの弁済を受領したときに消滅します。
        p|9. ユーザーは、本サービスのプライバシーポリシーに従い、個人情報を弊社に提供します。弊社はプライバシーポリシーに従い、オーナーに対して当該個人情報を提供することとし、ユーザーは本サービスを利用したことにより当該提供を異議なく同意したものとします。
        p|10. 本サービスのウェブサイト等上で掲げる本サービス利用に関するルール及びヘルプ等も、本規約の一部を構成するものとします。
        p|11. オーナーが安全確認その他の理由に基づきユーザーの所持する荷物の中身を確認する場合があります。万が一、ユーザーが確認を拒否した場合には、オーナーが荷物預かり契約の締結を拒否する場合があります。その場合、弊社は、一切責任を負わないこととします。
        p|12. ユーザーは、オーナーが、預かった荷物について法令違反又は本規約違反の疑いがあると合理的に判断する場合には、荷物の中身を確認することができること及び司法機関への通報その他必要な合理的な措置を執ることができることについて同意するものとします。オーナーが本項に定め措置を執ったことによってユーザー及び受取人に生じた損害について、弊所及びオーナーは一切責任を負わないものとします。
        p|13. ユーザーは、スペースに置く荷物は自己の所有物であり、自己に処分権限があることをユーザー及びオーナーに表明し保証します。
        p|14. ユーザーは、オーナーとの間で定めたスペースの利用期間を超えてスペースを利用することはできず、預けた荷物は利用期間内に撤去しなければなりません。ユーザーは、利用期間を超えた場合、超過料金等を支払うとともに、荷物等について第 11 条に基づいて移動等が行われることについて予め同意するものとします。
        p|15. ユーザーとオーナーの荷物預かり契約は、本サービスにてユーザーがスペースの利用を申し込んだときに、当該申込みの内容及び本規約に従って成立するものとします。
        p|16. ユーザーが本サービスを利用してオーナーとの間で定めたスペースを利用する期間内において、汚損、破損等の偶然な事故により生じた荷物の損害については、ユーザーを被保険者とする損害保険で補償される範囲においてその損害を弁済します。ユーザーは、弊社が契約するユーザーを被保険者とする損害保険の保険金の受取りに関する権利を弊社が有することに同意します。

      section
        h1|【 第 2 条 本規約の同意 】
        p|1. ユーザーは、本規約に同意したうえで、本規約の定めに従って本サービスを利用しなければならず、本サービスを利用することにより本規約に同意したものとみなされます。

      section
        h1|【 第 3 条 ユーザーの登録 】
        p|1. ユーザー登録は、ユーザーとなる本人が行ってください。本人以外のユーザー登録は認められません。
        p|2. ユーザー情報その他入力情報（以下「ユーザー情報等」という。）につき、虚偽の内容を登録することはできません。
        p|3. ユーザーは、常に正しいユーザー情報等を登録し、変更・管理をする義務を負うものとします。
        p|4. 前項の内容により、登録しているユーザー情報等に変更があった場合は、直ちに登録情報の更新を行ってください。
        p|5. 登録しているユーザー情報等の変更又は管理義務を怠ったことによる一切の損害等について、直接的又は間接的に関わらず、弊社は一切の責任を負いません。
        p|6. 登録しているユーザー情報等の変更又は管理を行い、弊社が更新を認めた時点から、新たな内容は適用されることとし、遡及効は発生しないものとします。
        p|7. 弊社は、ユーザー登録により生じる一切の損害等について、一切責任を負いません。
        p
          div|8. 本サービスを利用しようとする者は、本規約に同意の上、弊社に対しユーザー登録を申込み、弊社がこれを受諾した者のみがユーザーとなります。ただし、下記のいずれかに該当する者は、ユーザー登録をすることができません。また、ユーザーが登録後下記のいずれかに該当する者であることが判明した場合、弊社は登録の取消し等ができ、これに対しユーザーは異議を述べ、又は何らかの法的主張をすることはできません。
          div.i2|a. 当社に提供した登録事項の全部又は一部につき虚偽、誤記又は記載漏れがある者
          div.i2|b. 反社会的勢力（暴力団、暴力団員、右翼団体、反社会的勢力、その他これらに準ずる者、以下同じ。）に該当する又は資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力と何らかの交流もしくは関与を行っていると幣社が判断した者
          div.i2|c. 本規約に違反する恐れがあると認められる者
          div.i2|d. 未成年者、成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人､保佐人又は補助人の同意等を得ていなかった場合
          div.i2|e. その他、弊社が登録を適当でないと認めた者
        p|
          div|9. ユーザーの登録の取消しについて
          div.i2|a. ユーザーが以下に該当した場合、又は該当するおそれがあると弊社が判断した場合、弊社は当該ユーザーの登録の取消し及び本サービスの利用停止、並びに本サービスへのアクセス拒否を事前の通知なく行うことが出来ます。
          div.i3|ⅰ. 法令(法律・命令のほか条例・規則等も含む)又は本規約に違反したと認められる場合
          div.i3|ⅱ. 不正行為が認められる場合
          div.i3|ⅲ. ユーザーが登録した情報を弊社が虚偽の情報であると判断した場合
          div.i3|ⅳ. 弊社・他ユーザー・第三者に対し、善意・悪意、過失・無過失に関わらず、トラブルを起こした場合
          div.i3|ⅴ. 支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合、租税公課の滞納処分を受けた場合、差押、仮差押、仮処分、強制執行又は競売の申立てがあった場合又は登録されたクレジットカードもしくは電子マネーが利用できなくなった場合
          div.i3|ⅵ. 死亡した場合又は後見開始、保佐開始若しくは補助開始の審判を受けた場合
          div.i3|ⅶ. 12 ヶ月以上本サービスの利用がなく、弊社からの連絡に対して応答がない場合
          div.i3|ⅷ. 弊社がユーザーの登録の取消しが相当であると判断した場合

          div.i2|b. 前項に基づきユーザーの登録の取消しをした場合、ユーザーに関連する情報内容・コンテンツ（第 6 条で定義する。）の全部又は一部を削除し、その都度又は将来にわたり本サービスのご利用をお断りする場合があります。なお、その場合に弊社は、事前の通知なくしてこれを行い、ユーザーに対して説明義務を負いません。
          div.i2|c. ユーザーが、前記各号のいずれかの事由に該当した場合、ユーザーは、弊社及びオーナーに対して負っている債務の一切について当然に期限の利益を失い、直ちに弊社に対してかかる全債務の支払を行わなければなりません。弊社は、弊社が当該ユーザーに対して有する損害賠償請求権との相殺することができます。
          div.i2|d. 弊社は、ユーザーの登録の取消し等によりユーザーに生じる一切の損害等について、直接的又は間接的に関わらず一切の責任を負いません。

        p|10. ユーザーは、10 日営業日前までに弊社所定の方法で弊社に通知することにより、ユーザーの登録を取り消すことができます。但し、ユーザーが弊社及びオーナーに対する未払い債務があるときはこの限りではありません。

      section
        h1|【 第 4 条 ユーザー ID とパスワード 】
        p
          div|1. 本サービスを利用する為に使用するメールアドレス（以下「ユーザー ID」という。） とパスワードの管理
          div.i2|a. ユーザーは、ユーザー ID 及びパスワードの管理及び使用について責任を負うものとします。
          div.i2|b. ユーザーは、理由の如何を問わず、ユーザーID 及びパスワードを第三者に使用させてはならないものとします。ユーザーは、ユーザー ID 又はパスワードを第三者に利用、又は譲渡・売買、質入、貸与、若しくは賃貸その他形態を問わず処分することはできません。
          div.i2|c. 本サービスにおいてユーザー ID 又はパスワードが第三者に使用されたときは、その使用に関する本サービスにおける行為は全て当該ユーザーが行ったものとみなします。 それにより生じた一切の損害について、当該ユーザーがこれを負担するものとし、弊社は、善意・悪意、過失・無過失に関わらず、一切の責任を負いません。
        p
          div|2. ユーザー ID とパスワードの漏洩
          div.i2|a. 第三者にユーザー ID 及びパスワードの情報漏洩をした場合、速やかに弊社までご連絡ください。 弊社は当該ユーザー ID 及びパスワードの停止又は削除の措置を行います。
          div.i2|b. 情報漏洩により生じた一切の損害については、当該ユーザーが負担するものとし、弊社は原則として一切の責任を負いません。ただし、弊社の故意又は重過失により、ユーザー ID 及びパスワードが第三者に知られた場合については、この限りではありません。

      section
        h1|【 第 5 条 禁止行為 】
        p
          div|1. 弊社は、本サービスの利用をしたユーザーが、下記の禁止事項に該当する行為を禁止します。
          div.i2|a. 本規約に違反する行為
          div.i2|b. ユーザーがオーナーから提供されたスペースに、他人の所有物（ただし、当該他人から当該物について荷物預かり契約に関する処分権限を与えられている場合を除く。）、危険物、生物、異臭を放つ荷物、腐敗、変質若しくは損傷しやすい荷物、荷造りの不完全な荷物、法令若しくは公序良俗に違反する荷物、荷物の設置について特別の負担を求められる荷物、スペースにサイズが合わない荷物、又はその他スペースに置くことが適さない荷物を置く行為
          div.i2|c. スペースの利用により、弊社、オーナー及び第三者に迷惑をかける行為並びに弊社及びオーナーの指示に違反してスペースを利用する行為
          div.i2|d. オーナーとの間で定めたスペースの利用期間を超えてスペースを利用する行為
          div.i2|e. 法令(法律・命令のほか条例・規則等も含む)の定めに違反する行為、法令違反を助⾧する行為又はそれらのおそれのある行為
          div.i2|f. 公序良俗、一般常識に反する行為、又はそれを助⾧する行為又はそれらのおそれのある行為
          div.i2|g. 弊社、他のユーザー又は第三者への財産、プライバシー、肖像権若しくはパブリシティ権を侵害する行為、又は侵害するおそれのある行為
          div.i2|h. 弊社、他のユーザー又は第三者の秘密に属すべき情報を開示、又は開示を要求する行為、公開する行為
          div.i2|i. 弊社、他のユーザー又は第三者の情報を改ざん、消去する行為
          div.i2|j. 弊社、他のユーザー又は第三者を他のウェブサイトに誘導する行為
          div.i2|k. 弊社、他のユーザー又は第三者に不正プログラムを送信する又は他のコンピュータ・システム又はネットワークへの不正アクセスを試みる行為
          div.i2|l. 本サービスに関連するネットワーク・システムを妨害する行為
          div.i2|m. 本サービスで知り得た情報を弊社の許可なく開示、公開する行為
          div.i2|n. わいせつ、児童虐待にあたる画像、文書などを送信や掲載、リンクする行為、その他一般の方が不快に感ずるイメージ画像、言葉、その他の表現の掲載
          div.i2|o. 選挙運動又はこれに類似する行為、公職選挙法に違反する行為
          div.i2|p. 複数の利用者が閲覧可能な場所での金融機関口座番号の記載
          div.i2|q. 他の利用者になりすまして、本サービスを利用する行為
          div.i2|r. サーバーに負担をかける行為、及び他のユーザーのアクセス又は操作を妨害する行為
          div.i2|s. 本サービス運営又は利用に支障を与える行為
          div.i2|t. 本サービスの一部及び全部を使用・転用・転売・複製・送信・翻訳・翻案した弊社の許可していない本サービスの二次利用又は複製行為
          div.i2|u. 本サービスの一部又は全部を商業目的で利用する行為、無限連鎖講及びマルチ商法、それに類する行為又はそれらのおそれのある行為
          div.i2|v. その他、弊社が不適切と判断した行為
        p
          div|2. ユーザーが前項に該当する行為を行ったと弊社が判断した場合、弊社は、当該ユーザーに対し事前の通知なしに以下の措置を講じることができます。
          div.i2|a. 当該ユーザーが掲示した情報の削除
          div.i2|b. 当該ユーザーによる本サービスの一部又は全部の利用停止
          div.i2|c. ユーザー登録の取消し
          div.i2|d. 弊社に生じた損害の賠償の請求
          div.i2|e. その他弊社が必要と判断する措置
        p|3. 前項の措置を講じたことによる当該ユーザーの損害等については、直接的・間接的に関わらず、弊社は一切の責任は負いません。
        p
          div|4. 弊社は以下の各号に掲げる荷物に関しては、弊社独自の判断でスペースの提供を中止することができ、ユーザーは、当該判断に異議を申し出ることができないことに同意する。
          div.i2|a. 第 5 条第 1 項 2 号又は 3 号に該当する荷物
          div.i2|b. その他やむを得ない事由があるとき。
        p|5. ユーザーが第３条第８項各号、第３条第９項各号又は第５条第１項各号のいずれかに該当することを理由として、オーナーはユーザーとの荷物預かり契約を解除することができ、荷物預かり契約が解除された場合、ユーザーはこれを異議なく承諾し、直ちにスペースに置いた荷物を撤去して当該スペースをオーナーに明け渡さなければなりません。当該解除によりユーザーに損害等が生じた場合でも、弊社及びオーナーは、直接的・間接的に関わらず、一切の責任は負いません。

      section
        h1|【 第 6 条 コンテンツの削除 】
        p|1. 弊社は、弊社の判断でユーザーが本サービスを利用して投稿その他送信する文章、画像、動画その他のデータ（以下「コンテンツ」という。）が本サービスの内容として適切でない場合、事前の通知なくして任意に変更・削除等ができるものとします。
        p|2. 弊社は、弊社の判断で前項の内容により、ユーザーが本サービスを提供するウェブ上に掲載したあらゆるコンテンツに対しても、事前の通知なくして任意に削除等ができるものとします。

      section
        h1|【 第 7 条 弊社の知的財産権 】
        p|1. 本サービスに関する著作権等の知的財産権は、弊社又は第三者に帰属しており、日本国内外の著作権法及び著作者の権利・これに隣接する権利に関する諸条約並びにその他知的財産権に関する法令（以下「関連法令」という。）によって保護されています。本サービスの著作権その他知的財産権は、本サービスの閲覧者又は本サービス利用者に移転又は使用許諾されるものではありません。
        p|2. 本サービスの内容、その他関連資料等の著作権その他知的財産権は、弊社又は第三者に帰属し、これら関連資料は関連法令によって保護されています。
        p|3. サービスの閲覧者又は本サービス利用者は、前２項に定める当社又は第三者の知的財産権を侵害する一切の行為をしてはならず、本サービスの内容及びその他関連資料等に関して適用される関連法令を遵守する義務を負います。

      section
        h1|【 第 8 条 本サービス内容の中断・変更・終了 】
        p|1. 本サービスの障害、不具合、メンテナンス、その他の問題により、本サービスを継続できない場合があります。 また、弊社が必要と判断した場合には、本サービスをいつでも任意の理由で中断することができます。
        p|2. 弊社は、ユーザー及び第三者に対して事前の通知なしにいつでもサービスの内容を停止、変更(デザイン、システムなど)又は中止、若しくは終了する事ができます。
        p|3. 弊社は、本サービスの閲覧及び本サービスの利用ができないことによって引き起こされた損害について、直接的又は間接的に関わらず、一切責任を負いません。

      section
        h1|【 第 9 条 免責事項 】
        p|1. 弊社は、本サービスの中に、有害なものが含まれていないことを保証できません。 また、問題が発生した場合、修復、ウイルスその他有害要素の除去などを行うことを保証できません。 弊社は、有害なものが含まれていた場合、又は問題が発生した場合、修復、若しくはウイルスその他有害要素によって生じる直接的又は間接的な損害について、一切の責任を負いません。
        p|2. ユーザーは、任意の機器や通信サービスを自身の費用・責任において準備・購入・譲渡・契約等をした上で、本サービスの閲覧及び本サービスの利用を行ってください。 弊社は、ユーザーの利用環境に対して一切の関与をせず、利用環境等を理由に生じる一切の損害について、弊社に故意又は重大な過失がある場合を除き、直接的又は間接的に関わらず、一切の責任を負いません。
        p|3. ユーザーは、本サービスの内容、品質、正確性、適格性、適法性、安全性、信用性又は有用性等を、ユーザーが自ら判断してご利用ください。 弊社は、本サービスの使用によって生じる結果に関して保証できません。 弊社は、本サービスの閲覧及び本サービスの利用によって生じる直接的又は間接的な損害について、一切の責任を負いません。
        p|4. 本サービスは、弊社以外の第三者のサイトにリンクしている場合がありますが、このようなリンクはあくまでも情報提供の一環であり、リンク先サイトの内容について弊社は一切の責任を負うものではありません。 なお、リンク先サイトを利用する場合には、その利用上のルールを遵守してください。
        p|5. 荷物の損傷、紛失及び盗難その他オーナーが提供したスペースの利用によりユーザーに生じた損害について弊社は一切の責任を負いません。
        p|6. 本サービス又は弊社のウェブサイト等に関連してユーザーと他のユーザー、オーナーその他の第三者との間において生じた取引、連絡、紛争等については、ユーザーの責任において処理及び解決するものとし、弊社はかかる事項について一切責任を負いません。
        p|7. 弊社は、弊社が何らかの助言をした場合においても、その助言に従ったことによるいかなる保証もできません。

      section
        h1|【 第 10 条 損害賠償 】
        p|1. 本サービスの閲覧及び本サービスの利用を行うユーザーが、本規約に違反した場合、当該ユーザーは、弊社に対し、発生した損害を賠償していただきます。
        p|2. 消費者契約法の適用その他の理由（本規約に基づく場合も含むがこれに限られない。）により弊社がユーザーに対して損害賠償責任を負う場合においても、幣社の責任は、弊社の過失（重過失を除きます。）による債務不履行又は不法行為によってユーザーに生じた損害のうち現実に発生した直接かつ通常の損害に限り、かつ、当該損害の事由が生じた時点から遡って過去 3 か月の期間にユーザーから現実に受領した本サービスの利用料金の総額を上限とします。

      section
        h1|【 第 11 条 荷物が放置された場合の取扱い 】
        p|1. 荷物預かり契約で定めたスペースの利用期間経過後も、ユーザーの荷物がスペースに残置している場合（以下、残置された荷物を「残置荷物」」という。）は、ユーザーは、オーナーに対して所定の超過料金を支払うものとします。
        p|2. 前項の利用期間満了後５日間が経過しても残置荷物がユーザーにより撤去されない場合、弊社が残置荷物を回収し、弊社所定の倉庫にて 5 日間保管することとし、ユーザーは弊社に対して残置荷物の引き渡しを受ける代理権を付与するものとします。幣社がオーナーから荷物の引渡しを受けた場合、弊社とユーザーとの間で残置荷物に関して、新たな荷物預かり契約が成立し、ユーザーとオーナーとの間の契約関係は終了するものとします。
        p|3. 上記2.の事態が発生した場合、ユーザーは、幣社に対して、残置荷物についての倉庫への配送料、倉庫からの配送料及び保管料として、本サービスのウェブサイト記載のスペース利用料金（弊社が残置荷物を回収した日からユーザーに残置荷物を返還した日又は次項に基づき残置荷物を処分・廃棄した日までの期間を基準とする。）の２倍の料金を支払うものとします。
        p|4. 弊社所定の倉庫における残置荷物の保管期間が３０日間経過した場合、ユーザーは、弊社が残置荷物を自由に処分・廃棄することに関して同意し、所有権を放棄することに関して異議がないこととします。なお、ユーザーは弊社が残置荷物の内容等を確認せずに処分・廃棄することにも同意します。
        p|5. 本条に基づく弊社による残置荷物の回収、保管及び処分又は廃棄に関して第三者から弊社に対して何らかの訴え、異議、請求等がなされた場合において、弊社から処理の要請がなされたときは、ユーザーは自己の責任と費用負担において、弊社に代わって当該第三者との紛争を処理するとともに、弊社がかかる訴え、異議、請求等により被った一切の損害（弁護士費用を含む。）を賠償するものとします。

      section
        h1|【 第 12 条 キャンセルポリシー 】
        p|1. ユーザーが、荷物預かり契約の成立後、スペースの利用日当日に自己都合により荷物預かり契約を解約する場合、ユーザーは、オーナーに対して、キャンセル料として、利用料金全額に相当する額の支払義務が生じるものとします。
        p|2. ユーザーが、利用日の前日までに自己都合により荷物預かり契約を解約する場合には、キャンセル料は発生しません。

      section
        h1|【 第 13 条 ユーザー情報の取扱い 】
        p|1. 幣社によるユーザーの利用者情報の取扱いについては、別途当社プライバシーポリシーの定めによるものとし、ユーザーはこのプライバシーポリシーに従って弊社がユーザーの利用者情報を取り扱うことについて同意するものとします。
        p|2. 幣社は、ユーザーが幣社に提供した情報、データ等を、個人を特定できない形での統計的な情報として、丙社の裁量で、利用及び公開できるものとし、ユーザーはこれに異議を唱えないものとします。

      section
        h1|【 第 14 条 譲渡禁止等 】
        p|1. ユーザーは、弊社の書面による事前の承諾なく、本規約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。また、ユーザーは、弊社の書面による事前の承諾なく、スペースに置いた荷物の所有権を、当該荷物をスペースに置いている又は弊社が保管している間は、第三者に移転することはできません。
        p|2. 弊社は本サービスにかかる事業を第三者に譲渡（事業譲渡、会社分割その他態様の如何を問わないものとします。）した場合には、当該譲渡に伴い本規約上の地位、本規約に基づく権利及び義務並びにユーザーの登録情報その他の顧客情報を当該譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき本項において予め同意したものとします。

      section
        h1|【 第 15 条 有効期間 】
        p|1. 本規約に基づくユーザーとの契約は、ユーザーの登録が完了した日に効力を生じ、ユーザーの登録が取り消された日又は本サービスの提供が終了した日のいずれか早い日まで、有効に存続するものとします。

      section
        h1|【 第 16 条 準拠法・裁判管轄 】
        p|1. 本規約の準拠法は日本法とします。本規約の解釈又は本サービスに関してお客様と弊社との間に疑義や紛争が生じた場合には、誠意を持って協議するものとしますが、解決しない場合には、訴額に応じ、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。

      section
        h1|【 第 17 条 分離可能性 】
        p|1. 本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効と判断された既定の残りの部分は、継続して完全に効力を有するものとします。

      section
        h1|【 第 18 条 本規約の変更・追加・削除 】
        p|1. 弊社は、ユーザーに事前に通知なしに、本規約及び本規約に付随する規約の全部又は一部を任意に変更・追加・削除することができます。また、必要に応じて新たな規約等を追加でき、ユーザーはそれについても遵守する義務を負います。
        p|2. 弊社は、本規約の変更・追加・削除につき、幣社のウェブサイト等への掲示その他弊社が妥当と判断する方法で、ユーザーへの通知するものとし、当該変更内容の通知後、ユーザーが本サービスを利用した場合又は弊社の定める期間内に登録取消しの手続をとらなかった場合には、ユーザーは、本規約の変更に同意したものとみなす。
        p|3. 弊社は、本規約の変更・追加により利用者が被った損害につき、弊社に故意又は重過失がある場合を除き、直接的又は間接的に関わらず、一切の責任を負いません。
        p|4. 弊社は、弊社からの通知・連絡が届かない場合や遅延した場合に生じる損害について、一切の責任を負いません。

    section(v-else)
      |English translation is not done.
      |Check your Japanese.
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
h1
  font-size: 1.3rem
  text-align: center

.i2
  margin-left: 2em

.i3
  margin-left: 4em
</style>
